<template>
    <div class="modalVSelect">
        <h2 class="title">{{ $t(pageTitle) }}</h2>
        <v-select ref="modalSelect" :options="list" :value="val" @input="updateFunction" >
            <template slot="no-options">
                {{$t('sem-resultados-filtro')}}
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        list:{
            default: {},
        },
        updateFunction: Function,
        val:{
            default: () => [],
        },
        pageTitle: {
            default: "",
        }
    },
    data() {
        return {
            canSelect: false,
        };
    },
    mounted() {
        let search = this.$refs.modalSelect.$refs.search;
        search.addEventListener("keydown", this.tabSelect);
    },
    methods:{
        tabSelect(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelect = true;
            if(e.code == "Tab" && this.canSelect) {
                this.$refs.modalSelect.typeAheadSelect();
                this.canSelect = false;
            }
        },
    }
}
</script>

<style lang="scss">
// @import "../../../styles.scss";

.modalVSelect{
    width: 100%;

    >h2{
        font-weight: 500;
        font-size: 12px;
        color: $text-color;
        margin-bottom: 20px;
    }
}

</style>
